<template>
  <div class="pageContent">
    <!--顶部一条-->
    <mu-appbar>
      <span class="topT"> 提示 </span>
      <!--返回上一层-->
      <!--<mu-icon value="keyboard_arrow_left" color="white" style="margin-bottom: -0.05rem" slot="left" v-on:click="goOrderList" />-->
      <!--<mu-icon value="keyboard_arrow_left" color="#27ba69" slot="right" />-->
    </mu-appbar>

    <div style="width:100% ; " align="center" v-if=" this.$route.query.result == 'true' ">

      <div style="margin-top: 0.9rem  ">
        <img src="../../../static/hotel/打钩.png" style=" width:1.5rem " />
      </div>

      <div style="font-size:0.42rem ; color:#27BA69 ; margin-top:0.3rem">
        支付成功
      </div>

      <div style=" margin-top:0.6rem ; width:92% ; color:#333333 ; font-size: 0.28rem " align=" left">
        <mu-divider />
        <div style="  margin-top:0.26rem ;overflow:hidden;">
          <div style=" float:left"> 支付金额： </div>
          <div style=" float:right ; color:#999999  "> ￥ {{ this.Money }}
          </div>
        </div>

        <div style="  margin-top:0.26rem ;overflow:hidden;">
          <div style=" float:left"> 订单编号： </div>
          <div style=" float:right  ; color:#999999 "> {{this.OrderId }} </div>
        </div>

        <div style="  margin-top:0.26rem ;overflow:hidden;">
          <div style=" float:left"> 支付方式： </div>
          <div style=" float:right  ; color:#999999 "> {{this.PayType }} </div>
        </div>

        <div style="  margin-top:0.26rem ;overflow:hidden;">
          <div style=" float:left"> 交易时间： </div>
          <div style=" float:right  ; color:#999999 "> {{this.PayDate }} </div>
        </div>

        <mu-divider style=" margin-top:0.3rem  ;  margin-bottom:0.3rem" />

        <!--是储值卡用上面-->
        <div v-if=" this.g_PayOrder.PayFor=='Recharge' " align="center">
          <!-- 带边框的按钮 -->
          <div style=" width:95% ; margin-bottom:0.1rem ; overflow:hidden ">
            <div style=" border:1px solid #ff8f33 ; color:#ff8f33 ; text-align:center; width: 3rem ; height: 0.8rem ; float:left ; " v-on:click="gohome()">
              <div style=" padding-top:0.16rem ; font-size:0.3rem "> 返回首页 </div>
            </div>
            <div style=" width:0.3rem ; height:0.57rem ; float:right "> </div>
            <div style="   border: none ;background-color:#ff8f33  ; color:#fff ; text-align:center; width: 3rem ; height:0.8rem;  float:right " v-on:click="gowallet()">
              <div style=" padding-top:0.16rem ; font-size:0.3rem "> 查看储值卡 </div>
            </div>
          </div>

        </div>

        <div v-else align="center">

          <!--<div style="text-align:left; font-size:0.24rem  ; color:#999999 ; line-height: 1.8  ;  margin-bottom:0.2rem ">
                  备注：如遇特殊情况，不能及时入住，您可以在
                  【入住当日】18:00 前免费取消订单。若未入住或过时取消，将收取您首日房费
                </div>
                <mu-divider style=" margin-top:0.3rem  ;  margin-bottom:0.38rem" />-->
          <!-- 带边框的按钮 -->
          <div style=" width:95% ; margin-bottom:0.1rem ; overflow:hidden ">
            <div v-on:click="gohome()" style=" border:1px solid #ff8f33 ; color:#ff8f33 ; text-align:center; width: 3rem ; height: 0.8rem ; float:left ; ">
              <div style=" padding-top:0.16rem ; font-size:0.3rem "> 返回首页 </div>
            </div>
            <div style=" width:0.3rem ; height:0.57rem ; float:right "> </div>
            <div v-on:click="goOrderDetails()" style="   border: none ;background-color:#ff8f33  ; color:#fff ; text-align:center; width: 3rem ; height:0.8rem;  float:right ">
              <div style=" padding-top:0.16rem ; font-size:0.3rem "> 查看订单详情 </div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <div style="width:100% ; " align="center" v-if=" this.$route.query.result == 'false' ">

      <div style="margin-top: 0.9rem  ">
        <img src="../../../static/hotel/打叉.png" style=" width:1.5rem " />
      </div>
      <div style="font-size:0.42rem ; color:#ff9647 ; margin-top:0.3rem">
        支付失败
      </div>
      <div style="font-size:0.28rem ; color:#666666 ; margin-top:0.36rem">
        失败原因： {{Message}}
      </div>

      <div style=" margin-top:0.8rem ; width:92% ; color:#333333 ; font-size: 0.28rem " align=" left">
        <mu-divider style="    margin-bottom:0.6rem" />

        <div style="   " align="center">
          <div style=" width:95% ; margin-bottom:0.1rem ; overflow:hidden ">
            <div v-on:click="goOrderDetails()" style=" border:1px solid #ff8f33 ; color:#ff8f33 ; text-align:center; width: 3rem ; height: 0.8rem ; float:left ; ">
              <div style=" padding-top:0.16rem ; font-size:0.3rem "> 查看订单详情 </div>
            </div>

            <div style=" width:0.3rem ; height:0.57rem ; float:right "> </div>
            <div v-on:click="goPayMoney()" style="   border: none ;background-color:#ff8f33  ; color:#fff ; text-align:center; width: 3rem ; height:0.8rem;  float:right ">
              <div style=" padding-top:0.16rem ; font-size:0.3rem "> 重新支付 </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!--{{  this.$route.query.result  }}-->

    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />

  </div>
</template>








<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";

export default {
  computed: {
    ...mapGetters(["g_UserInfo", "g_PayOrder"])
  },
  activated() {
    this.init();
  },
  data() {
    return {
      // 弹出层
      toast: false,
      TellUser: "",
      // 弹出标签 选择是否
      dialog: false,

      Message: "",

      OrderId: "",
      Money: "",
      PayType: "",
      PayDate: ""
    };
  },
  methods: {
    ...mapMutations(["setG_PayOrder", "setG_UserInfo"]),

    init() {
      var UserInfo = this.g_UserInfo;
      UserInfo.OrderRefresh1 = true;
      this.setG_UserInfo(UserInfo);

      if (this.$route.query.result == "true") {
        this.OrderId = this.$route.query.parentNo;
        this.Money = this.$route.query.money;
        this.PayType = unescape(this.$route.query.paytype);
        this.PayDate = unescape(this.$route.query.payDate);

        // this.setG_PayOrder( Order );

        // this.$router.push({ path: '/order/PayByStoredValueCard' });
      } else {
        this.Message = unescape(this.$route.query.message);
      }
    },

    // 订单 - 支付房费 - 储值卡  1
    gohome() {
      this.$router.push({ path: "/home/index" });
    },
    goOrderDetails() {
      if (this.$route.query.orderType == 2)
        this.$router.push({ path: "/user/breakfast" });
      else this.$router.push({ path: "/order/orderdetails" });
    },

    goOrderList() {
      // this.$router.push({ path: '/home/index' });
      if (this.g_UserInfo.IsOtherUser) {
        this.$router.push({ path: "/home/ordertorelax" });
      } else {
        this.$router.push({ path: "/home/order" });
      }
    },

    gowallet() {
      this.$router.push({ path: "/wallet/valueCardDetail" });
      // this.$router.push({ path: '/home/wallet' });
    },

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 1500);
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    }
    // 弹出层  end
  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/order/PayIsOk") >= 0) {
        this.init();
      }
    }
  }
};
</script>




// paper模块
<style lang="less" scoped>
@import "../../assets/theme.less";
.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor;
  border: 1px solid @primaryColor;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%;
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange;
  }
  .Black {
    color: @primaryBlack;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// PayIsOk.vue?d99f5342